import { render } from "./Model.vue?vue&type=template&id=66d7ed68&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"

import "./Model.vue?vue&type=style&index=0&id=66d7ed68&scoped=true&lang=less"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d7ed68"]])

export default __exports__